import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Provider } from 'react-redux';
import {
  About,
  Footer,
  Home,
  Projects,
  Testimonials,
} from './containers';
import { Navbar } from './components';
import store from './redux/configureStore';
import { pageVariants } from './containers/Pagevariants/Pagevariants';
import './App.scss';

const App = () => {
  const [loading, setLoading] = useState(true);
  const spinner = document.getElementById('spinner');

  if (spinner) {
    setTimeout(() => {
      spinner.style.display = 'none';
      setLoading(false);
    }, 3000);
  }

  const [scrollY, setScrollY] = useState(0);
  // const controls = useAnimation();

  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return (
    !loading && (
      <motion.div className="app">
        <Provider store={store}>
          <Navbar />
          <AnimatePresence mode="wait">
            <motion.div
              initial="initial"
              animate="animate"
              variants={pageVariants}
            >
              <motion.div
                id="home"
                initial={{ opacity: 1 }}
                animate={{
                  opacity: scrollY >= 300 ? 0 : 1,
                  transition: { duration: 0.5 },
                }}
                exit={{
                  opacity: 1,
                  transition: { duration: 0.5 },
                }}
              >
                <Home />
              </motion.div>
              <motion.div
                id="about"
                initial={{ opacity: 0 }}
                animate={{
                  opacity: scrollY >= 300 ? 1 : 0,
                  height: '100vh',
                  top: 0,
                  y: 0,
                  transition: { duration: 0.5 },
                }}
                exit={{
                  opacity: 0,
                  transition: { duration: 0.5 },
                }}
              >
                <About />
              </motion.div>
              <motion.div
                id="projects"
                initial={{ opacity: 0 }}
                animate={{
                  opacity: scrollY >= 300 ? 1 : 0,
                  transition: { duration: 0.5 },
                }}
                exit={{
                  opacity: 0,
                  transition: { duration: 0.5 },
                }}
              >
                <Projects />
              </motion.div>
              <motion.div
                id="testimonials"
                initial={{ opacity: 0 }}
                animate={{
                  opacity: scrollY >= 300 ? 1 : 0,
                  transition: { duration: 0.5 },
                }}
                exit={{ opacity: 0 }}
              >
                <Testimonials />
              </motion.div>
              <motion.div
                id="contacts"
                initial={{ opacity: 0 }}
                animate={{
                  opacity: scrollY >= 300 ? 1 : 0,
                  transition: { duration: 0.5 },
                }}
                exit={{ opacity: 0 }}
              >
                <Footer />
              </motion.div>
            </motion.div>
          </AnimatePresence>
        </Provider>
      </motion.div>
    )
  );
};

export default App;
